import { styled, Grid } from "@mui/material";

export const Container = styled(Grid)({
  "& .MuiRadio-root": {
    padding: "0px 10px",
  },
});

export const AnswerBlock = styled(Grid)({
  padding: "5px 0px 10px 20px",
});
